import { cx } from "@emotion/css";
import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import routing from "routing";
import PickerItems from "src/images/Icons/newIcons/itemsList.svg";
import FlashcardIcon from "src/images/Icons/newIcons/navigation/flashcards.svg";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";

import { Header } from "../../../Main/ExamsBox/ExamsBox";
import { DefaultPicker } from "./DefaultPicker";

export function FlashcardsDeckChoicePicker() {
	const { t } = useTranslation();

	const searchDecksPath = generatePath(routing.paths.searchQuestion, {
		type: (routing.searchTypes as Record<string, string>).decks,
	});

	return (
		<DefaultPicker
			emptyText=""
			Header={
				<Header
					title={t("contentPicker.flashcards.title", "Fiszki")}
					icon={<FlashcardIcon className={cx("icon-super-big icon-purple")} />}
					withBackButton
				/>
			}
			boxes={[
				{
					title: t(
						"contentPicker.flashcards.createOwn.title",
						"Stwórz własny zestaw",
					),
					subtitle: t(
						"contentPicker.flashcards.createOwn.subtitle",
						"Utwórz swój nowy zestaw fiszek Twój zostaw może być prywatny lub publiczny.",
					),
					path: routing.paths.createDeck,
					submitText: t("commands.create", "Utwórz"),
					Icon: PickerNewItem,
					variant: "primary",
					testId: "flashcards-create-own",
				},
				{
					title: t(
						"contentPicker.flashcards.browseExisting.title",
						"Wybierz z gotowych zestawów",
					),
					subtitle: t(
						"contentPicker.flashcards.browseExisting.subtitle",
						"Wybierz zestaw z szerokiej listy i ucz się materiałów z przygotowanych i sprawdzonych treści",
					),
					path: searchDecksPath,
					submitText: t("commands.browse", "Przeglądaj"),
					Icon: PickerItems,
					variant: "primary",
					testId: "flashcards-browse-existing",
				},
				{
					title: t(
						"contentPicker.flashcards.importMany.title",
						"Importuj wiele zestawów",
					),
					subtitle: t(
						"contentPicker.flashcards.importMany.subtitle",
						"Stwórz wiele zestawów fiszek na raz, importując pliki csv, txt czy też anki",
					),
					path: routing.paths.importDecks,
					submitText: t("creators.decks.importDecks", "Importuj zestawy"),
					Icon: Upload,
					variant: "primary",
					testId: "flashcards-import-many",
				},
			]}
		/>
	);
}
